module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    attrs: {
      "header-text-variant": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": _vm.$t('groupSettlement.groupSettlementReview'),
      "alternativeRoute": "group-settlement/list"
    }
  })], 1), _vm._v(" "), _c('datatable', {
    attrs: {
      "url": _vm.groupSettlementsUrl,
      "name": "group-settlements-table",
      "columns": _vm.tColumns,
      "options": _vm.tOptions
    },
    scopedSlots: _vm._u([{
      key: "amount",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatAmount(props.row.amount)))])]
      }
    }, {
      key: "creationDate",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatDate(props.row.creationDate)))])]
      }
    }, {
      key: "dueDate",
      fn: function(props) {
        return [(props.row.dueDate) ? _c('span', [_vm._v(_vm._s(_vm.formatDate(props.row.dueDate)))]) : _c('span', [_vm._v("-")])]
      }
    }, {
      key: "settledAmount",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatAmount(props.row.settledAmount)))])]
      }
    }, {
      key: "settlementDate",
      fn: function(props) {
        return [(props.row.settlementDate) ? _c('span', [_vm._v(_vm._s(_vm.formatDate(props.row.settlementDate)))]) : _c('span', [_vm._v("-")])]
      }
    }, {
      key: "debtorName",
      fn: function(props) {
        return (props.row.debtorId !== 0) ? [_c('router-link', {
          attrs: {
            "to": {
              name: 'approvedUserPage',
              params: {
                registrationId: props.row.debtorId
              }
            }
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.debtorName))])])] : undefined
      }
    }, {
      key: "groupSettlementStatus",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-sm",
          class: [{
              'btn-danger': [_vm.groupSettlementStatus.CANCELLED, _vm.groupSettlementStatus.INVALID].includes(props.row.groupSettlementStatus)
            },
            {
              'btn-success': _vm.groupSettlementStatus.SETTLED === props.row.groupSettlementStatus
            },
            {
              'btn-info': ![_vm.groupSettlementStatus.CANCELLED, _vm.groupSettlementStatus.INVALID, _vm.groupSettlementStatus.SETTLED].includes(props.row.groupSettlementStatus)
            }
          ]
        }, [_vm._v(_vm._s(_vm.$t('groupSettlement.groupSettlementStatus.' + props.row.groupSettlementStatus)))])]
      }
    }], null, true)
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'registerGroupSettlementRoute'
      }
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('groupSettlement.createNew')) + "\n            "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-32dae221", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32dae221","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/group-settlement/list-group-settlement/ListGroupSettlement.vue
// module id = 776
// module chunks = 1